var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkedinIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.35798 15H0.248045V4.98536H3.35798V15ZM1.80114 3.61929C0.806815 3.61929 0 2.79536 0 1.80107C0 1.3234 0.189762 0.865288 0.527541 0.527522C0.865319 0.189755 1.32344 0 1.80114 0C2.27883 0 2.73695 0.189755 3.07473 0.527522C3.41251 0.865288 3.60227 1.3234 3.60227 1.80107C3.60227 2.79536 2.79546 3.61929 1.80114 3.61929ZM14.9973 15H11.8944V10.125C11.8944 8.96304 11.8708 7.47321 10.2775 7.47321C8.66067 7.47321 8.41262 8.73536 8.41262 10.0414V15H5.3059V4.98536H8.28833V6.35143H8.33173C8.74692 5.56446 9.76106 4.73411 11.274 4.73411C14.4214 4.73411 15 6.80679 15 9.49875V15H14.9973Z",
    fill: "#153DCB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinIcon);
export default __webpack_public_path__ + "static/media/linkedin-icon.1923ad53ac2af16aab811067c150c521.svg";
export { ForwardRef as ReactComponent };